import React, { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/AKHSoftLogo.png';
import { Menu, X } from 'lucide-react'; // Optional: You can use your own icons

function Header() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="w-full sticky top-0 z-50 bg-white shadow">
      <div className="max-w-[1910px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        
        {/* Logo */}
        <div className="flex items-center space-x-2 sm:space-x-3">
          {/* Uncomment to use logo */}
          {/* <img src={logo} alt="AKHSoft Logo" className="h-8 w-8 sm:h-10 sm:w-10 object-contain" /> */}
          <span className="text-2xl sm:text-4xl font-extrabold tracking-wide text-[#0a3c6d]">
            <span>AKH</span><span>Soft</span>
          </span>
        </div>

        {/* Hamburger Menu Button (Mobile only) */}
        <button
          className="sm:hidden text-[#0a3c6d]"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden sm:flex gap-4 items-center">
          {[
            { name: "Home", to: "/" },
             { name: "About", to: "/about" },
            { name: "Services", to: "/services" },
            // { name: "Portfolio", to: "#" },
           
            { name: "Contact", to: "/contact" },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-sm sm:text-base ${
                location.pathname === item.to
                  ? "text-[#166298] font-semibold"
                  : "text-gray-700"
              } hover:text-[#166298]`}
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </div>

      {/* Mobile Navigation Dropdown */}
      {isOpen && (
        <div className="sm:hidden bg-white border-t shadow-md px-6 pb-4">
          {[
            { name: "Home", to: "/" },
             { name: "About", to: "/about" },
            { name: "Services", to: "/services" },
            // { name: "Portfolio", to: "#" },
           
            { name: "Contact", to: "/contact" },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={closeMenu}
              className={`block py-2 text-sm ${
                location.pathname === item.to
                  ? "text-[#166298] font-semibold"
                  : "text-gray-700"
              } hover:text-[#166298]`}
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}

export default Header;
